import React from 'react';
import DocFaby from '../../images/foto-faby.478b28e0.jpg';
import DocMontse from '../../images/foto-monse.64d09495.jpg';
import '../../css/About.css';
import TituloPagina from '../../js/Components/PageTitle';

type Dentist = {
  name: string;
  role: string;
  photo: string;
  phone: string;
  email: string;
  accent: string;
};

const dentists: Dentist[] = [
  {
    name: 'Dra. Ana Fabiola Puente Villafaña',
    role: 'Cirujano Dentista y Especialista en Ortodoncia',
    photo: DocFaby,
    phone: '33 34 75 81 91',
    email: 'faby.puente@live.com',
    accent: 'Ortodoncia y atención integral',
  },
  {
    name: 'Dra. Montserrat Puente Villafaña',
    role: 'Cirujano Dentista y Especialista en Endodoncia',
    photo: DocMontse,
    phone: '3316369641',
    email: 'montc.mcr@gmail.com',
    accent: 'Endodoncia y atención integral',
  },
];

const About: React.FC = () => {
  return (
    <div>
      <TituloPagina title="DentalPuente | Acerca De" />

      <main className="about-page content-wrap">
        <section className="about-hero">
          <div>
            <span className="about-eyebrow">Acerca de DentalPuente</span>
            <h1>Un equipo dental cercano, profesional y claro contigo</h1>
            <p>
              En DentalPuente buscamos que cada paciente se sienta escuchado, bien orientado y acompañado durante su tratamiento dental.
            </p>
          </div>
          <div className="about-hero-card">
            <strong>Teodomiro Manzano 4365</strong>
            <span>Guadalajara, Jalisco</span>
            <a href="/Contact">Ver contacto</a>
          </div>
        </section>

        <section className="about-values-grid">
          <article>
            <span>01</span>
            <h3>Diagnóstico honesto</h3>
            <p>Explicamos tu caso y las opciones disponibles sin complicarte.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Tratamiento humano</h3>
            <p>Atención amable para que tu visita sea más cómoda y tranquila.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Seguimiento dental</h3>
            <p>Nos enfocamos en cuidar el resultado y prevenir problemas futuros.</p>
          </article>
        </section>

        <section className="about-team-section">
          <div className="about-section-header">
            <span className="about-eyebrow">Nuestro equipo</span>
            <h2>Doctoras DentalPuente</h2>
            <p>Profesionales enfocadas en salud, estética, prevención y bienestar dental.</p>
          </div>

          <div className="about-dentist-list">
            {dentists.map((dentist) => (
              <article className="about-dentist-card" key={dentist.email}>
                <div className="about-dentist-photo-wrap">
                  <img src={dentist.photo} alt={dentist.name} className="about-dentist-photo" />
                </div>
                <div className="about-dentist-info">
                  <span className="about-specialty-pill">{dentist.accent}</span>
                  <h3>{dentist.name}</h3>
                  <h4>{dentist.role}</h4>
                  <div className="about-contact-grid">
                    <div className="about-contact-item">
                      <span>☎</span>
                      <div>
                        <strong>Teléfono</strong>
                        <p>Citas {dentist.phone}</p>
                      </div>
                    </div>
                    <div className="about-contact-item">
                      <span>✉</span>
                      <div>
                        <strong>Email</strong>
                        <p>{dentist.email}</p>
                      </div>
                    </div>
                    <div className="about-contact-item about-contact-wide">
                      <span>⌖</span>
                      <div>
                        <strong>Dirección</strong>
                        <p>Teodomiro Manzano 4365, Guadalajara, Jal.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
